import { memo } from 'react'
import { MapPreview as Layout } from 'ui-components'
import { MapGl } from '~map-preview/App/Map'
import { MapEmbedFullscreenButton } from '~map-preview/App/Tools/MapEmbedFullscreenButton'
import { MapLegend } from '~map-preview/App/Tools/MapLegend'
import { MapName } from '~map-preview/App/Tools/MapName'
import { MapTable } from '~map-preview/App/Tools/MapTable'
import { NavDrawer } from '~map-preview/App/Tools/NavDrawer'
import { useIsEmbed } from '~map-preview/hooks/useIsEmbed'

export const Main = memo(() => {
  const isEmbed = useIsEmbed()

  return (
    <Layout
      isEmbed={isEmbed}
      slots={{
        MapTable,
        MapEmbedFullscreenButton,
        MapGl,
        MapLegend,
        MapName,
        NavDrawer
      }}
    />
  )
})
